import { TextPassage } from '@petsmart-ui/sparky';
import './MinimumQuantityLabel.scss';

const hideTextQty = 1;
const defaultToZero = (value?: number) => value ?? 0;
type MinimumQuantityLabelProps = {
    minimumCaseQty?: number;
    className?: string;
};

export default function MinimumQuantityLabel({
    minimumCaseQty,
    className = 'moq',
}: MinimumQuantityLabelProps) {
    if (defaultToZero(minimumCaseQty) <= hideTextQty) {
        return null;
    }

    return (
        <div data-testid="min-qty-text" className={className}>
            <TextPassage className="moq-fields--text-passage">
                Minimum quantity of {minimumCaseQty} required.
            </TextPassage>
        </div>
    );
}
